import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Link } from "react-router-dom";
import { fmtDateTime } from "../lib/format";
import { Bell, CheckCheck } from "lucide-react";

export default function Notifications() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/notifications").then(r => setItems(r.data));
  useEffect(() => { load(); }, []);
  const markAll = async () => { await api.post("/notifications/read-all"); load(); };
  const markOne = async (id) => { await api.post(`/notifications/${id}/read`); load(); };
  return (
    <div className="space-y-6 max-w-3xl">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-[11px] tracking-[0.2em] uppercase text-gold font-bold mb-2">Inbox</div>
          <h1 className="font-display text-4xl font-bold tracking-tighter text-navy">Notifications</h1>
        </div>
        <button onClick={markAll} className="btn-outline" data-testid="mark-all-read">
          <CheckCheck size={14} /> Mark all read
        </button>
      </div>
      <div className="card-base divide-y divide-slate-100">
        {items.length === 0 && <div className="p-10 text-center text-slate-400">No notifications.</div>}
        {items.map(n => (
          <div key={n.notification_id} className={`p-4 flex items-start gap-3 ${n.read ? "" : "bg-amber-50/40"}`} data-testid={`notification-${n.notification_id}`}>
            <div className={`w-8 h-8 rounded-md flex items-center justify-center flex-shrink-0 ${n.read ? "bg-slate-100" : "bg-gold/20"}`}>
              <Bell size={14} className={n.read ? "text-slate-500" : "text-navy"} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-slate-900">{n.title}</div>
              <div className="text-sm text-slate-600 mt-0.5">{n.message}</div>
              <div className="text-xs text-slate-400 mt-1">{fmtDateTime(n.created_at)}</div>
            </div>
            <div className="flex flex-col gap-2 items-end">
              {n.link && <Link to={n.link.replace("/loads/", "/app/loads/")} className="text-xs text-gold font-semibold hover:underline">Open</Link>}
              {!n.read && <button onClick={() => markOne(n.notification_id)} className="text-xs text-slate-500 hover:text-navy" data-testid={`mark-read-${n.notification_id}`}>Mark read</button>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
